import { useMemo } from "react";
import { useWeekdays } from "./common/useWeekdays";
import { useIntlTokens } from "./components/mobile/useIntlTokens";
import { capitalizeFirstLetter } from "./utils";

export function useWeekdayFormattedString(weekdays: number[]) {
  const weekdayNames = useWeekdays("short");

  const selectedWeekdays = useMemo(
    () => weekdays.sort((a, b) => a - b),
    [weekdays]
  );

  const intl_tokens = useIntlTokens();
  const weekdaysString = useMemo(() => {
    if (
      selectedWeekdays.length === 2 &&
      selectedWeekdays[0] === 5 &&
      selectedWeekdays[1] === 6
    ) {
      return intl_tokens.Weekends;
    }
    if (
      selectedWeekdays.length === 5 &&
      selectedWeekdays[0] === 0 &&
      selectedWeekdays[1] === 1 &&
      selectedWeekdays[2] === 2 &&
      selectedWeekdays[3] === 3 &&
      selectedWeekdays[4] === 4
    ) {
      return intl_tokens.Weekdays_excluding_weekend;
    }

    if (selectedWeekdays.length === 7) {
      return null;
    }

    return selectedWeekdays
      .map((w) => capitalizeFirstLetter(weekdayNames[w]))
      .join(", ");
  }, [
    intl_tokens.Weekdays_excluding_weekend,
    intl_tokens.Weekends,
    selectedWeekdays,
    weekdayNames,
  ]);

  return weekdaysString;
}
